import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUpdatedDiyDetails } from "../post-inspection-diy/actions";
import PostInspectionDiyAuctionTimerWrapper from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        similarCarSoldCount
    },
    scriptLoaderReducer: {
        googlemap
    }
}) => ({
    inspectionResponse,
    googlemap,
    similarCarSoldCount
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getUpdatedDiyDetailsConnect: getUpdatedDiyDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyAuctionTimerWrapper);
